import * as React from "react";

const SvgLightSleetThunderSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSleetThunderSun_svg__a">
        <path d="M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSleetThunderSun_svg__b">
        <path d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSleetThunderSun_svg__c">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSleetThunderSun_svg__d">
        <path d="M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSleetThunderSun_svg__e">
        <path d="m1380.107 682.253-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSleetThunderSun_svg__f">
        <path d="m1380.107 682.253-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#LightSleetThunderSun_svg__a)"
      style={{
        fill: "#fec225",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
    >
      <g
        style={{
          fill: "#fec225",
          fillOpacity: 1,
        }}
      >
        <path
          d="M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
          style={{
            fill: "#fec225",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSleetThunderSun_svg__b)"
      style={{
        fill: "#fec425",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -372.778 763.845)"
    >
      <g
        style={{
          fill: "#fec425",
          fillOpacity: 1,
        }}
      >
        <path
          d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
          style={{
            fill: "#fec425",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSleetThunderSun_svg__c)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(322.129 528.494)"
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSleetThunderSun_svg__d)"
      style={{
        fill: "#d3e9f8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
    >
      <g
        style={{
          fill: "#d3e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
          style={{
            fill: "#d3e9f8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 384 -86.15)"
      d="M-288 64.612h72v72h-72z"
    />
    <g
      clipPath="url(#LightSleetThunderSun_svg__e)"
      style={{
        fill: "#dbecf9",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1766.45 973.41)"
    >
      <g
        style={{
          fill: "#dbecf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1380.107 682.253-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
          style={{
            fill: "#dbecf9",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSleetThunderSun_svg__f)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1782.45 973.41)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1380.107 682.253-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgLightSleetThunderSun;
